
import React from "react";
import FixButton from "../widgets/Button";
import getPresenze from "../services/getPresenze";
import addPresenza from "../services/addPresenza";
import deletePresenze from "../services/deletePresenze";
import getCorso from "../services/getCorso";
import getStudenti from "../services/getStudenti";
import Cookies from 'universal-cookie';
import TextNumberInput from "./TextNumberInput";

class InnerPresenzaWidget extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            value: this.props.value,
            slots: this.props.value2, 
            isLoading: true,
        }
    }

    componentDidMount() {
        this.setState({ isLoading: false })
    }

    setValue(val, notes){
        this.setState({value:val})
        this.props.onChange && this.props.onChange(val, notes);
    }

    render(){

        if(this.state.isLoading) return <div />;

        return (
            <div style={{display: 'flex', height: '30px', marginTop: '10px', cursor: 'pointer'}}>
                <div style={this.state.value == -1 ? red : defaultColor}
                onClick={() => this.setValue(-1, this.state.slots)}
                >A</div>
                <div style={this.state.value == 1 ? green : defaultColor}
                onClick={() => this.setValue(1, this.state.slots)}
                >P</div>    
                <div>
                    <TextNumberInput placeholder={'Ore differenti'} value={this.state.slots} inputStyle={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', height: '40px', marginTop: '-10px', width: '150px', marginLeft: '15px', marginRight: '30px' }} onChange={(text) => {
                        this.setState({slots: text});
                        this.setValue(this.state.value, text);
                    }
                    
                    } />
                </div> 
            </div>
        );
    }

    
}

export default class PresenzeWidget extends React.Component {

    constructor (props){
        super(props);

        this.results = [];
        this.notes = [];

        this.state = {
        }
    }

    getValue(){
        let value = 0;
        return value;
    }

    async componentDidMount(){
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const lezione = this.props.lezione;
        this.dbPath = cookies.get('db_path', { path: '/' });

        let presenze = await getPresenze(username, token, lezione.id);
        this.studenti = await getStudenti(username, token);

        this.corsiObj = [];

        for (var corso of this.props.corsi){
            var tempCorso = await getCorso(username, token, corso);
            this.corsiObj[corso] = tempCorso;
            this.setState({});
        }

        this.studentiLezione = this.studenti.filter(s => {
            var present = false;
            
            this.props.corsi.forEach(c => {
                if (this.corsiObj[c] == undefined) return;
                if (s.corsi.indexOf(c) != -1 && !s.corsi_ritiro.includes(c + ';')) present = true;
            });

            return present;
        })

        presenze.forEach(p => {
            this.results[p.id_studente] = p.presenza;
            this.notes[p.id_studente] = p.ore;
            this.setState({});
        })

        this.setState({});
    }

    render (){
        return ( 
        <div key={Math.random()} style={widgetClass}>
            {
                this.studenti && this.props.corsi.map(corso => {
                
                    var studentiCorso = this.studenti.filter(s => s.corsi.indexOf(corso+";") != -1 && s.corsi_ritiro.indexOf(corso+';') == -1);

                    if (corso == '') return null;
                    if (this.corsiObj[corso] == undefined) return null;

                    return (     
                        <div style={{ marginBottom: 20 }}>       
                    <div style={{textAlign: 'left', fontSize: '25px', marginBottom: 15}}>{this.corsiObj[corso].name}</div>
                    <table style={mainClass}>
                        {
                            studentiCorso.sort((s1, s2) => {
                                if (s1.cognome > s2.cognome || s1.cognome == s2.cognome && s1.nome > s2.nome)
                                    return 1;
                                else return -1;
                            }).map(s => 
                                    (<div key={Math.random()} style={presenzeRow}>
                                        <td style={nameColumn}>{s.cognome + ' ' + s.nome}</td>
                                        <td> <InnerPresenzaWidget value={this.results[s.id]} value2={this.notes[s.id]} onChange={(val, notes) => {
                                            this.results[s.id] = val;
                                            this.notes[s.id] = notes;
                                        }}/></td>
                                    </div>)
                            )
                        }
                    </table></div>)
                })
            }

            <br/>

            <FixButton title={'Save'} callback={async () => {
              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              const lezione = this.props.lezione;

              var errorNotFound = false;
              this.studentiLezione.forEach(s => {
                  if (this.notes[s.id] != undefined && this.notes[s.id] != ''){
                      var note = parseFloat(this.notes[s.id]);
                      if (isNaN(note))
                          errorNotFound = true;
                  }
              })

              if (errorNotFound){
                alert ("Inserire un numero per le ore di presenza.");
                return;
              }

              errorNotFound = false;
              this.studentiLezione.forEach(s => {
                  if (this.results[s.id] == undefined)
                      errorNotFound = true;
              })

              if (errorNotFound == true){
                  alert ("E' necessario segnare la presenza o l'assenza di TUTTI gli studenti per continuare.");
              } else{
                  await deletePresenze(username, token, lezione.id);
                  this.studentiLezione.forEach(async (s) => {
                    await addPresenza(username, token, lezione.id, s.id, this.results[s.id], this.notes[s.id]);
                })
                window.location.href= this.dbPath + '/#/app/schedule';


              }
              
              }
          } />

        </div>
        )
    }
}

const widgetClass = {
    padding: '5px',
    width: '600px', 
    marginTop: 30,
}


const mainClass = {
    padding: '5px',
    width: '300px'
}

const green = {
    color: 'white', 
    padding: '5px',
    borderRadius: '15px',
    textAlign: 'center',
    fontWeight: 'bold',
    width: '30px',
    height: '30px',
    backgroundColor: 'green',
}

const red = {
    color: 'white', 
    padding: '5px',
    borderRadius: '15px',
    textAlign: 'center',
    fontWeight: 'bold',
    width: '30px',
    height: '30px',
    backgroundColor: 'red',
}

const defaultColor = {
    color: 'black', 
    padding: '5px',
    width: '30px', 
    height: '30px',
    textAlign: 'center',
    backgroundColor:  'white',
}

const presenzeRow = {
    backgroundColor: 'white',
    borderRadius: '10px', 
    boxShadow: '0px 2px 10px darkgrey',
    paddingTop: 5, 
    paddingBottom: 5, 
    paddingLeft: 10,
    marginBottom: 5,
    display: 'flex',
    minHeight: '50px',
}

const nameColumn = {
    position: 'relative', 
    top: 5, 
    left: 10, 
    width: '150px',
    lineHeight: '40px',
    height: '50px',
    marginRight: 15
}